const fields = [
  'PDB_Backend_Verbindungsmethode',
  'PDB_Backend_Routertyp',
  'PDB_Backend_NetzwerkHost',
  'PDB_Backend_Internetanschluss',
  'PDB_Backend_LucomRouter',
  'PDB_Backend_KonfigurationLucomRouter',
  'PDB_Backend_LucomConnectRouter',
  'PDB_Backend_ZusaetzlicheInformationen',
]


const key = 'Netzwerkinformationen'
export const fieldOrderNetzwerkinformationen = {
  [key]: { fields: fields },
}

export const formGroupNetzwerkinformationen = {
  key: key,
  title: key,
  form: key,
}